import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { logIn } from '../../store/actions/authActions'
import Button from '../../components/Button.js'

const Login = (props) => {
    const initState = {
        email: '',
        password: '',
        rememberMe: true,
    }

    const [loginState, setLoginState] = useState(initState)
    const dispatch = useDispatch()

    const handleSubmit = (event) => {
        event.preventDefault()
        dispatch(logIn(loginState))
    }

    const handleChange = (event) => {
        setLoginState({
            ...loginState,
            [event.target.name]: event.target.value
        })
    }

    return (
        <section id='login' className='pb-5 md:pb-0'>
            <h2 className='text-center my-2'>Entrar</h2>
            <form noValidate method='POST'>
                <div className="mb-4">
                    <label className="block text-gray-700 font-bold mb-2">
                        <span>Email</span>
                        <input
                            type="text"
                            name='email'
                            placeholder="Escreva aqui o seu email"
                            onChange={handleChange}
                            className="text-sm shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 my-3"
                        />
                    </label>

                </div>
                <div className="mb-6">
                    <label className="block text-gray-700 font-bold mb-2">
                        <span>Palavra-passe</span>
                        <input
                            type="password"
                            name='password'
                            placeholder="Escreva aqui a sua palavra-passe"
                            onChange={handleChange}
                            className="text-sm shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 my-3"
                        />
                    </label>
                </div>

                <div className="flex-col mt-auto mb-8">
                    <p className='inline-block link text-sm mb-3' onClick={() => props.scrollFunction()}>
                        Ainda não tem conta? Registe-se aqui.
                    </p>
                    <p className='text-sm mb-2'><Link to='/recuperar-password'>Esqueceu-se da palavra-passe?</Link></p>
                </div>

                <hr className='mb-6'/>

                <Button className='mr-0 float-right' onClick={(event) => handleSubmit(event)}>Entrar</Button>
                {/* <div className='flex justify-between mt-5 py-3'>
                    <Link className='otherLinks text-sm'>Entrar com a conta da Google</Link>
                    <Link className='otherLinks text-sm mr-0'>Entrar com a conta do Facebook</Link>
                </div> */}
            </form>
        </section>
    )
}

export default Login